import script from "./bootstrap-modal.vue?vue&type=script&setup=true&lang=ts"
export * from "./bootstrap-modal.vue?vue&type=script&setup=true&lang=ts"

import "./bootstrap-modal.vue?vue&type=style&index=0&id=901084e0&lang=css"

const __exports__ = script;

export default __exports__